module.exports = __webpack_public_path__ + "img/ic_qmarker_asset_cluster_issue.8f5d7850.png";